import { AxiosInstance } from "axios";
import { ITicket } from "../interfaces/ITicket";

export class TicketService {
    protected apiClient: AxiosInstance;

    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
    }

    async getAll(eventId: string): Promise<ITicket[]> {
        try {
            const response = await this.apiClient.get(`/admin/event/${eventId}/ticket`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async get(eventId: string, id: string): Promise<ITicket> {
        try {
            const response = await this.apiClient.get(`/admin/event/${eventId}/ticket/${id}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async create(eventId: string, ticket: ITicket): Promise<ITicket> {
        try {
            const response = await this.apiClient.post(`/admin/event/${eventId}/ticket`, ticket);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async update(eventId: string, id: string, ticket: ITicket): Promise<ITicket> {
        try {
            const response = await this.apiClient.put(`/admin/event/${eventId}/ticket/${id}`, ticket);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async delete(eventId: string, id: string): Promise<void> {
        try {
            await this.apiClient.delete(`/admin/event/${eventId}/ticket/${id}`);
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
}